import * as React from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { Formik, Field, FormikHelpers } from 'formik';
import * as Yup from 'yup';

import { AppState } from '../../../store';
import { UserContainer, BackgroundImage, Form, FormFields, Title, SubTitle, UserForm } from '../../../styles/styled-components/User/User';
import { ChangePasswordFormPayload, Authentication } from '../../../models/authentication';
import { actionChangePassword } from '../../../store/authentication/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { parseJWT, getCurrentAppLang } from '../../../helpers/util';
import { FormField } from '../../../components/FormField/FormField';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';
import FormError from '../../../components/FormError/FormError';

interface ChangePasswordProps extends RouteComponentProps<any> {
  changePassword: (payload: ChangePasswordFormPayload) => void;
  authentication: Authentication;
}

interface ChangePasswordViewStates {
  password: string;
  confirmPassword: string;
  loader: boolean;
}

class ChangePassword extends React.Component<ChangePasswordProps, ChangePasswordViewStates> {

  private userId = '';

  state: ChangePasswordViewStates = {
    password: '',
    confirmPassword: '',
    loader: false,
  };

  componentDidMount() {
    if (this.props.authentication.verifiedOTPToken) {
      const decodeToken = parseJWT(this.props.authentication.verifiedOTPToken);
      this.userId = decodeToken.uid;
    }
  }

  async handleSubmit(values: ChangePasswordViewStates, actions: FormikHelpers<ChangePasswordViewStates>) {
    this.setState({ loader: true });
    const language = getCurrentAppLang(true).split('_')[1];
    await this.props.changePassword({ userId: this.userId, password: values.password, token: this.props.authentication.verifiedOTPToken, locale: language });
    if (this.props.authentication.error && this.props.authentication.error.status) {
      actions.setStatus({ error: 'form.generic.error' });
      this.setState({ loader: false });
    }
    if (!this.props.authentication.error) {
      this.props.history.push(`change-password-success`);
    }
  }

  render() {
    if (!this.props.authentication.verifiedOTPToken) {
      this.props.history.push(`forgot-password`);
    }

    const validationSchema = Yup.object().shape({
      password: Yup.string().min(8, 'form.password.error.min').required('form.password.error.empty'),
      confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'form.confirmPassword.error.match').required('form.confirmPassword.error.empty'),
    });

    return (
      <UserContainer>
        <BackgroundImage />
        <UserForm>
          <Formik initialValues={this.state}
            onSubmit={(values, actions) => this.handleSubmit(values, actions)}
            validationSchema={validationSchema}>
            {({ status }) => (
              <Form method="POST">

                <Title>{i18next.t('changePassword.title')}</Title>
                <SubTitle>{i18next.t('changePassword.text')}</SubTitle>
                <FormError name="ChangePassword" data={status} />

                <FormFields>

                  <FormField name="password" label={i18next.t('changePassword.newpassword')} >
                    <Field name="password" className="input" type="password" maxLength={50} placeholder={i18next.t('changePassword.newpasswordPlaceholder')} />
                  </FormField>

                  <FormField name="confirmPassword" label={i18next.t('changePassword.confirmpassword')}>
                    <Field name="confirmPassword" className="input" type="password" maxLength={50} placeholder={i18next.t('changePassword.confirmpasswordPlaceholder')} />
                  </FormField>

                  <SubmitButton loader={this.state.loader} >
                    {i18next.t('changePassword.continueButton')}
                  </SubmitButton>

                </FormFields>
              </Form>
            )}
          </Formik>
        </UserForm>

      </UserContainer>
    );
  }
}

const mapStateToProps = (state: AppState, ownProps: ChangePasswordProps) => {
  return {
    authentication: state.authentication,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    changePassword: (payload: ChangePasswordFormPayload) => dispatch(actionChangePassword(payload)),
  };
};

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));